import { useEffect } from 'react';
import { getObjectKeys } from '../../../common/utils/getObjectKeys';
import { useSearchHistory } from './useSearchHistory';
import { useStateWithPartialSet } from './useStateWithPartialSet';

export function useSearch<ISearchState extends object>(cleanSearchState: ISearchState) {
    const [history, pushHistory] = useSearchHistory<ISearchState>(cleanSearchState);
    const [searchState, setSearchState] = useStateWithPartialSet<ISearchState>(history);

    useEffect(() => {
        const isHistoryDifferent = getObjectKeys(searchState).some((key) => history[key] !== searchState[key]);
        if (isHistoryDifferent) {
            setSearchState(history);
        }
    }, [history]);

    return [searchState, setSearchState, pushSearchStateToHistory] as const;

    function pushSearchStateToHistory(state: ISearchState = searchState) {
        pushHistory(state);
    }
}
